import React from 'react';

function HowToImplementMF2026({ translations }) {
  return (
    <section className="bg-swiss-150 py-12">
      <div className="container mx-auto max-w-5xl px-6 md:px-12">
        <h2
          className="text-white text-center text-2xl md:text-3xl font-bold mb-8"
          dangerouslySetInnerHTML={{ __html: translations?.title }}
        />

        <ol className="text-white text-center space-y-2">
          {Array.isArray(translations?.steps) &&
            translations.steps.map((step, index) => (
              <li
                key={index}
                className="text-sm md:text-base"
                dangerouslySetInnerHTML={{ __html: `${index + 1}. ${step}` }}
              />
            ))}
        </ol>

        <div className="mt-8">
          <p
            className="text-white text-center text-sm md:text-base leading-relaxed px-4"
            dangerouslySetInnerHTML={{ __html: translations?.closingText }}
          />
        </div>
      </div>
    </section>
  );
}

export { HowToImplementMF2026 };
